module.exports = __webpack_public_path__ + "img/28exp.4ed5ad5b.jpg";